import React from 'react';

const SocialHandle = (props) => {
    let {url} = props;
    let icon = props.icon ? <i className={props.icon}/> : props.children;
    if(url && url !="" && url !=null){
        return <a href={props.url} target='_blank'>{icon}</a>
    }
    return null;
}

export default SocialHandle;